import { useContext } from 'react';
import { ParentContext } from '../contexts/ParentContext';

const useParent = () => {
  return useContext(ParentContext);
};

export default useParent;
